import { decodeNumberToColor, encodeColorToNumber } from "@nova/serializer/src/client/util"
import * as Icons from "@nova/component-icons"
import { ColorPicker } from "./ColorPicker"
import classNames from "classnames"

const transparentColor = encodeColorToNumber("#FFFFFF01")
export const ColorPalette = ({
    swatches,
    includeTransparentOption,
    selectedColor,
    setSelectedColor,
    setOpenDropdownId,
    triggerResize,
    allowColorPicker = true,
}: {
    swatches: number[]
    includeTransparentOption?: boolean
    selectedColor: number
    setSelectedColor: (color: number) => void
    setOpenDropdownId: (id: string | undefined) => void
    triggerResize?: () => void
    allowColorPicker?: boolean
}) => {
    return (
        <div className="rounded-xl flex gap-2 p-2 bg-gray-700 shadow-card relative items-center">
            {swatches.map((color, i) => (
                <div
                    key={i}
                    className={classNames("relative rounded-[0.4375rem] border", {
                        "border-gray-0": selectedColor === color,
                        "border-transparent": selectedColor !== color,
                    })}
                    onClick={() => {
                        setSelectedColor(color)
                        setOpenDropdownId(undefined)
                        triggerResize?.()
                    }}
                >
                    <Icons.Icon
                        Icon={Icons.SquareSwatch}
                        style={{ color: decodeNumberToColor(color) }}
                        className="hover:brightness-125 cursor-pointer"
                    />
                    {selectedColor === color && (
                        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
                            <Icons.ExtraSmallIcon
                                Icon={Icons.CheckmarkShadow}
                                className="text-gray-0 pointer-events-none"
                            />
                        </div>
                    )}
                </div>
            ))}
            {includeTransparentOption && (
                <div
                    className={classNames("relative rounded-[0.4375rem] border", {
                        "border-gray-0": selectedColor === transparentColor,
                        "border-transparent text-gray-400": selectedColor !== transparentColor,
                    })}
                    onClick={() => {
                        setSelectedColor(transparentColor)
                        setOpenDropdownId(undefined)
                        triggerResize?.()
                    }}
                >
                    <Icons.Icon
                        Icon={Icons.TransparentSwatch}
                        className="hover:brightness-125 cursor-pointer"
                    />
                    {selectedColor === transparentColor && (
                        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
                            <Icons.ExtraSmallIcon
                                Icon={Icons.CheckmarkShadow}
                                className="text-gray-0 pointer-events-none"
                            />
                        </div>
                    )}
                </div>
            )}
            {allowColorPicker && (
                <div className="absolute top-full left-1/2 -translate-x-1/2">
                    <ColorPicker
                        selectedColor={decodeNumberToColor(selectedColor)}
                        setSelectedColor={(color) => setSelectedColor(encodeColorToNumber(color))}
                    />
                </div>
            )}
        </div>
    )
}
